import { focusModeSet } from 'redux/actions/focusMode'
import store from 'redux/store'

export function cancelFocusMode(): boolean {
  store.dispatch(focusModeSet({ showFocusMode: false }))
  return true
}
